import { getProviderFactoryForService, Model, AccessorsMutatorsDecorator } from '../../helpers';

/**
 * @class ConfigPmsApiService
 * @property {$injector} $injector
 * @property {string} endpoint
 * @property {function():<Token|Object|null>|Array.<string|function():<Token|Object|null>>} authTokenGetter
 */
export class ConfigPmsApiService extends Model {

    static get $inject() {

        return [ '$injector' ];
    }

    /**
     * @type {string}
     */
    get authToken() {

        const token = this.$injector.invoke(this.authTokenGetter);

        return token && token.token ? token.token : '';
    }

    /**
     * @param {$injector} $injector
     * @param {Object.<string, *>} attributes
     */
    constructor($injector, attributes = {}) {

        super(Object.assign({
                                endpoint: '',
                                authTokenGetter: () => null
                            }, attributes));

        this.$injector = $injector;
    }
}

AccessorsMutatorsDecorator('endpoint', 'authTokenGetter')(ConfigPmsApiService);

export class ConfigPmsApiServiceProvider {

    static get $inject() {

        return [];
    }

    /**
     * @type {Object.<string, *>}
     */
    set config(config) {

        this._config = config;
    }

    /**
     * @type {Object.<string, *>}
     */
    get config() {

        return this._config;
    }

    /**
     * @type {Function}
     */
    get $get() {

        return getProviderFactoryForService(this, ConfigPmsApiService, 'config');
    }

    constructor() {

        this._config = {};
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/config.service.js